import { BASE_URL } from '@helpers/constants'
import setAuthorization from '@helpers/setAuthorization'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export interface ResearchRequest {
	researchOriginSkip: boolean
	researchOriginOption?: string | null
	researchOriginOptionOther?: string
}

export interface ResearchResponse {
	hasResearchOrigin: boolean
}

export const researchAPI = createApi({
	reducerPath: 'researchAPI',
	tagTypes: ['Research'],
	baseQuery: fetchBaseQuery({
		baseUrl: BASE_URL,
		prepareHeaders: (headers, { endpoint, getState }) =>
			setAuthorization(headers, { getState, endpoint }),
	}),
	endpoints: (builder) => ({
		listResearch: builder.query<ResearchResponse, void>({
			query: () => ({
				url: '/research',
				method: 'GET',
			}),
			providesTags: ['Research'],
		}),

		createResearch: builder.mutation<ResearchResponse, ResearchRequest>({
			query: (body) => ({
				url: '/research',
				method: 'POST',
				body,
			}),
			invalidatesTags: ['Research'],
		}),
	}),
})
